import { css } from "@emotion/react";
import type { PropsWithChildren } from "react";

export function AuthLayout({ children }: PropsWithChildren) {
  return (
    <main
      css={css`
        width: 100%;
        height: 100vh;
        overflow: hidden;
        /* Premium Sandal & Teal Mesh Gradient */
        background-color: #f7f3f0;
        background-image: 
            radial-gradient(at 0% 0%, rgba(20, 186, 182, 0.4) 0px, transparent 50%),
            radial-gradient(at 100% 0%, rgba(212, 163, 115, 0.5) 0px, transparent 50%),
            radial-gradient(at 100% 100%, rgba(20, 186, 182, 0.3) 0px, transparent 50%),
            radial-gradient(at 0% 100%, rgba(212, 163, 115, 0.4) 0px, transparent 50%),
            radial-gradient(at 50% 50%, rgba(255, 255, 255, 0.6) 0px, transparent 80%);
        background-attachment: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
      `}
    >
      <div
        css={css`
            background-color: #ffffff;
            width: 100%;
            max-width: 480px;
            padding: 48px;
            border-radius: 24px;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04), 0 0 0 1px rgba(0, 0, 0, 0.05);
            z-index: 1;
            transform: translateY(-20px);
            animation: slideUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
            display: flex;
            flex-direction: column;
            
            @keyframes slideUp {
                from { opacity: 0; transform: translateY(60px); }
                to { opacity: 1; transform: translateY(-20px); }
            }
        `}
      >
        {children}
      </div>
    </main>
  );
}
